<template>
  <div class="leco-content">
    <transition appear mode="out-in">
      <div class="auth-page">
        <div class="container mt-4 mb-5">
          <div class="row">
            <div class="col-md-6 offset-md-3 col-xs-12">
              <h1 class="text-center mb-4">Sign in</h1>
              <div v-if="errorMessages.length > 0" class="alert alert-danger">
                <ul>
                  <li v-for="msg in errorMessages" :key="msg">{{ msg }}</li>
                </ul>
              </div>
              <form @submit.prevent="login(email, password)">
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="text"
                    v-model="email"
                    placeholder="Email"
                  />
                </fieldset>
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="password"
                    v-model="password"
                    placeholder="Password"
                  />
                </fieldset>

                <button class="btn btn-lg btn-outline-secondary float-right">
                  Sign in
                </button>

                <br />
                <router-link :to="{ name: 'password-reset' }">
                  <h6>パスワードを忘れた場合</h6>
                </router-link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { SET_AUTH, PURGE_ERROR } from "@/store/mutations.type";

export default {
  name: "LecoLogin",
  data() {
    return {
      email: null,
      password: null,
      errorMessages: [],
      logger: this.$store.state.logger
    };
  },
  methods: {
    login() {
      this.errorMessages = [];

      // 必須入力チェック
      if (this.email == "") this.errorMessages.push("Eメールは必須項目です。");
      if (this.password == "")
        this.errorMessages.push("パスワードは必須項目です。");
      if (this.errorMessages.length > 0) return;

      this.$store.commit(PURGE_ERROR);
      this.$cognito
        .login(this.email, this.password)
        .then((result) => {
          this.logger.debug("auth set before.");
          this.logger.debug("cognito login result:" + JSON.stringify(result));
          this.$store.commit(SET_AUTH, result.signInUserSession);
          this.$store.commit(PURGE_ERROR);
          this.logger.debug("auth set after.");
          this.logger.info("login completed.");

          let redirectUrl = this.$route.query.redirect;
          this.logger.info("redirect url:" + redirectUrl);
          if (redirectUrl === undefined) {
            this.$router.replace("/");
          } else {
            this.$router.replace(redirectUrl);
          }
        })
        .catch((err) => {
          if (err.code == "NotAuthorizedException") {
            this.errorMessages.push(
              "ユーザー名またはパスワードが誤っています。"
            );
            return;
          } else {
            this.logger.error(JSON.stringify(err));
            this.errorMessages.push("認証エラー。" + err.message);
            return;
          }
        });
    }
  }
};
</script>

<style scoped>
.auth-page {
  flex: 1;
}
</style>
